module.exports = __webpack_public_path__ + "img/dnxzs.1ca6f7f.png";